import {LeftPanelBody} from './components/left-panel-body';
import {LeftPanelHeader} from './components/left-panel-header';
import {LeftPanelRoot} from './components/left-panel-root';

export const LeftPanel = {
	Root: LeftPanelRoot,
	Header: LeftPanelHeader,
	Body: LeftPanelBody,
};
